import { Select, Space } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import {
	useGetAllRegularMaintenanceQuery,
	useGetMaintenanceByVehicleQuery,
} from "../../../Redux/service/Maintenance/Maintenance";

export default function MaintenanceMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedVehicles, setSelectedVehicles] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AllMaintenance, refetch: AllMaintenanceRefetch } =
		useGetAllRegularMaintenanceQuery(undefined, {
			refetchOnMountOrArgChange: true,
		});
	let { data: MaintenanceByVehicle, refetch: MaintenanceByVehicleRefetch } =
		useGetMaintenanceByVehicleQuery(vehicleId, {
			skip: !vehicleId,
			refetchOnMountOrArgChange: true,
		});
	console.log("before Selected:", MaintenanceByVehicle);

	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};

	const isFirstMount = useRef(true);
	useEffect(() => {
		if (AllMaintenance) {
			const merged = [...AllMaintenance];
			const unique = merged.filter(
				(item, index, self) => index === self.findIndex((t) => t.id === item.id)
			);
			setMergedData(unique);
		}
	}, [AllMaintenance]);
	useEffect(() => {
		if (isFirstMount.current || AllMaintenanceRefetch) {
			console.log(mergedData);
			if (mergedData?.length > 0) {
				setGroups(
					mergedData?.map((i) => ({
						value: i.id,
						label: i.name,
					}))
				);
			}
		}
		isFirstMount.current = false;
	}, [mergedData, AllMaintenanceRefetch]);

	useEffect(() => {
		if (isLinking) {
			if (type === "maintenance" && vehicleId) {
				AllMaintenanceRefetch();
			}
		}
	}, [isLinking, type, AllMaintenanceRefetch]);

	useEffect(() => {
		if (MaintenanceByVehicle) {
			setSelectedVehicles(MaintenanceByVehicle.map((i) => i.id));
			console.log("MaintenanceByVehicle Selected:", MaintenanceByVehicle);
		}
	}, [MaintenanceByVehicle]);

	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedVehicles((prev) => [...prev, value]);
						handleLink(value, "maintenance", "Vehicle");
					}}
					onDeselect={(value) => {
						setSelectedVehicles((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "maintenance", "Vehice");
					}}
					value={selectedVehicles || undefined}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
